import IconLink from '../icons/IconLink';

function ContentHeader({ prevStep, label }: { prevStep: () => void; label: string }) {
    return (
        <div className="fireknife-content-header">
            <div className="fireknife-content-header__box">
                <a
                    className="fireknife-content-header__link"
                    onClick={(e) => {
                        e.preventDefault();
                        prevStep();
                    }}
                >
                    <IconLink className="fireknife-content-header__link-icon" />
                    <span className="fireknife-content-header__link-text">{label}</span>
                </a>
            </div>
        </div>
    );
}

export default ContentHeader;
